export default __webpack_public_path__ + "static/media/portfolio-157.eff76261.jpg";